module.exports = __webpack_public_path__ + "static/media/2_MTA - New York City.0b72e9a2.jpg";